<div class="contact-box">
    <div class="row h-100 center-align">
        <div class="col-4" (click)="call();" style="cursor: pointer;">
            <div class="icon">
                <i class="fas fa-mobile-alt"></i>
            </div>
        </div>
        <div class="col-8">
            <p>
                الجوال
                01141087755-002
            </p>
        </div>
    </div>
</div>